module.exports = __webpack_public_path__ + "static/images/gift-bg-l.6883df2.png";